var _circle, _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWeather(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("foreignObject", {
    x: -25,
    y: -25,
    width: 101,
    height: 101
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(12.5px)",
      clipPath: "url(#bgblur_0_1166_38597_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    "data-figma-bg-blur-radius": 25,
    cx: 25.5,
    cy: 25.5,
    r: 25,
    fill: "url(#paint0_linear_1166_38597)",
    fillOpacity: 0.2,
    stroke: "url(#paint1_linear_1166_38597)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 34.125C29.4873 34.125 33.125 30.4873 33.125 26C33.125 21.5127 29.4873 17.875 25 17.875C20.5127 17.875 16.875 21.5127 16.875 26C16.875 30.4873 20.5127 34.125 25 34.125Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.925 34.925L33.7625 34.7625M33.7625 17.2375L33.925 17.075L33.7625 17.2375ZM16.075 34.925L16.2375 34.7625L16.075 34.925ZM25 13.6V13.5V13.6ZM25 38.5V38.4V38.5ZM12.6 26H12.5H12.6ZM37.5 26H37.4H37.5ZM16.2375 17.2375L16.075 17.075L16.2375 17.2375Z",
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_1166_38597_clip_path",
    transform: "translate(25 25)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 25.5,
    cy: 25.5,
    r: 25
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1166_38597",
    x1: 25.5,
    y1: 0,
    x2: 25.5,
    y2: 51,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1166_38597",
    x1: -17.5,
    y1: -24.5,
    x2: 30,
    y2: 10,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeather);
export default __webpack_public_path__ + "static/media/weather.e93bc4db0d2572f2892b448754ce1952.svg";
export { ForwardRef as ReactComponent };